var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rootComponent)?_c(_vm.rootComponent,{tag:"component",attrs:{"routeData":_vm.modulData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }